import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6pds9k9e3d: FaireBrandEntity = {
  token: "b_6pds9k9e3d",
  type: "brand",
  name: "Sweet Deliverance",
  avatarUrl:
    "https://cdn.faire.com/fastly/c67b2b40395d76f229eed7172cc556ed92fb7f5f79030aaed2e3dd92bdbd9a1c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8728b91f15cedf6e82daca60cd536a8557656dce169efdc925c6f796a851a868.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c67b2b40395d76f229eed7172cc556ed92fb7f5f79030aaed2e3dd92bdbd9a1c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8728b91f15cedf6e82daca60cd536a8557656dce169efdc925c6f796a851a868.png",
  location: "Kingston, NY, USA",
  minimumOrderDollars: 36,
  rating: 4.9,
  reviewCount: 28,
  isTopShop: true,
  isInsider: true,
  description:
    "We’ve set out to prove that granola deserves to be more than just sugar and oats.\n\nSweet Deliverance began in chef and postpartum doula Kelly Geary’s kitchen, when a nutrient-dense, seed-forward granola was created to support a client’s prenatal needs. The recipe quickly became a favorite among friends, family, and neighbors—and soon, a growing community of fans.\n\nToday, Sweet Deliverance offers a collection of inspired flavors made with nourishing seeds, nuts, and spices, using organic and gluten-free ingredients wherever possible. Designed to fuel your day from morning to night, our granolas are crafted with care in small batches.\n\nAs a women-owned brand, Sweet Deliverance is on a mission to elevate everyday nourishment—one bowl or handful at a time.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:45.059Z",
    importedBy: "entity-db-cli",
  },
};
